import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ReviewResponseCard from './ReviewResponseCard.js';

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: 0,
    paddingTop: '1rem',
  },
});

const ReviewResponseCardList = ({data, providerName}) => {
  const classes = useStyles();
  if (data.length === 0) {
    return null;
  }
  return (
    <div className={classes.root}>
      {data.map((item, i) =>
        <ReviewResponseCard key={i} data={item} providerName={providerName}/>
      )}
    </div>
  );
};

ReviewResponseCardList.propTypes = {
  data: PropTypes.array,
  providerName: PropTypes.string.isRequired,
};

export default ReviewResponseCardList;
